import { useUIStore } from '@/stores/ui'
import { IconX } from '@/components/icons'
import { classNames } from '@/lib/utils'

export function ToastContainer() {
  const toasts = useUIStore((s) => s.toasts)
  const dismissToast = useUIStore((s) => s.dismissToast)

  if (toasts.length === 0) return null

  return (
    <div className="fixed top-4 left-1/2 z-50 flex -translate-x-1/2 flex-col gap-2">
      {/* Newest toast (appended last in the store) renders first here, right at the anchor
          point at the top — the natural feel for a top-anchored stack, where a fresh toast
          should appear at the edge and push older ones down rather than showing up furthest
          from it. */}
      {[...toasts].reverse().map((toast) => (
        <div
          key={toast.id}
          className={classNames(
            'flex items-center gap-3 rounded-lg px-4 py-3 shadow-lg',
            toast.exiting ? 'toast-exit' : 'toast-enter',
            toast.type === 'success' && 'bg-green-50 text-green-800 border border-green-200',
            toast.type === 'error' && 'bg-red-50 text-red-800 border border-red-200',
            toast.type === 'info' && 'bg-secondary-50 text-secondary-800 border border-secondary-200',
          )}
        >
          <span className="text-sm font-medium">{toast.message}</span>
          <button onClick={() => dismissToast(toast.id)} className="ml-2 text-current opacity-50 hover:opacity-100">
            <IconX className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
